import { Container } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { styled } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import DelendAppBar from "../components/AppBar/DelendAppBar";
import DelendAsideAppBar from "../components/AppBar/DelendAsideAppBar";

import { Profile } from "../@types/profile";
import { useAppSelector } from "../hooks/hooks";

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme }) => ({
    flexGrow: 1,
    height: "100%",
    padding: theme.spacing(3),
  })
);

const DrawerHeader = styled("div")(({ theme }) => {
  const profile = useAppSelector<Profile | undefined>(
    (state) => state.profileSlice.profile
  );

  return {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(profile && !profile.email_verified ? 8 : 0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  };
});

const Dashboard = () => {
  return (
    <Container maxWidth={"xl"} sx={{ display: "flex" }}>
      <CssBaseline />

      <DelendAppBar />

      <DelendAsideAppBar />

      <Main>
        <DrawerHeader />
        <Outlet />
      </Main>
    </Container>
  );
};

export default Dashboard;
